// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- 3rd Party
import { HubConnection } from '@microsoft/signalr';
import * as signalR from '@microsoft/signalr';
import { User as OidcUser } from 'oidc-client';

// --- HS Code
import { OidcService } from '../account/oidc.service';
import { environment } from '../../../../environments/environment';
import { UserNotificationBaseService } from './user-notification-base.service';
import { NotificationModel } from '../../../models';
import { ReportsBaseService } from '../reporting/reports-base.service';
import { IdleTimeoutService } from '../idle-timeout.service';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class UserNotificationService extends UserNotificationBaseService {
  private _hubConnection: HubConnection | undefined;
  private _isConnected: boolean = false;
  private _isConnecting = false;


  constructor(
    reportsService: ReportsBaseService,
    private oidcService: OidcService,
    private idleTimeoutService: IdleTimeoutService) {
    super(reportsService);

    this.idleTimeoutService.idleState$.subscribe((idleState) => {
      if (idleState === 'active' && !this._isConnected && !this._isConnecting) {
        this.connect();
      } else if (idleState === 'idle' && !!this._isConnected) {
        this.signOut();
      }
    });
  }

  connect(): void {
    this.idleTimeoutService.resetIdleTimeCounter();
    if (!this._isConnected && !this._isConnecting) {
      this._isConnecting = true;
      this.oidcService.identity$.subscribe(user => {
        if (user != null) {
          this._initHub(user);
        }
      });
    }
  }

  private _initHub(user: OidcUser) {
    const token = user.access_token;

    const url = environment.apiConfig.surveyApiUrl + environment.apiConfig.hubApi;

    this._hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${url}`, { accessTokenFactory: () => token })
      .configureLogging(signalR.LogLevel.Information)
      .withAutomaticReconnect()
      .build();

    this._hubConnection.on('Notify', (notification: NotificationModel) => {
      this._processNotification(notification);
    });

    this._hubConnection.start()
      .then(() => {
        this._isConnecting = false;
        this._isConnected = true;
      })
      .catch((err: any) => {
        this._isConnecting = false;
        this._isConnected = false;
        console.error(err.toString());
      });
  }

  signOut(): void {
    if (!this._hubConnection) {
      return;
    }
    
    this._hubConnection.stop()
      .then(() => {
        this._isConnecting = false;
        this._isConnected = false;
      })
      .catch((err: any) => {
        this._isConnecting = false;
        this._isConnected = false;
        console.error(err.toString());
      });
  }

  view(notification: NotificationModel): void {
    const notifications = this._notifications$.value;
    notifications.forEach((notificationItem, index: number) => {
      if (notificationItem.id === notification.id) {
        notificationItem.isRead = true;
      }
    });

    this._notifications$.next(notifications);
  }
  remove(notification: NotificationModel): void {
    const notifications = this._notifications$.value;
    const notificationIndex = notifications.findIndex(x => x.id === notification.id);
    if (typeof notificationIndex !== 'undefined') {
      notifications.splice(notificationIndex, 1);
    }
    this._notificationList = notifications;
    this._notifications$.next(notifications);
  }
}
